import { getDecimal } from '@/helpers/numbers';
//import ParameterService from './parameters';

const state = {
  resume: [],
  postDevQaValue: 0,
  TestSupportValue: 0,
  deploiementMin: 0,
  deploiementMax: 0
};
export const actions = {
  getDataForExcel({ commit, getters, rootState }) {

    let postDevQaIndex = this.getters['parameters/getIndex']('PostDevQa');
    let testSupportIndex = this.getters['parameters/getIndex']('TestSupport');
    commit('setQAValue', postDevQaIndex.defaultValue);
    commit('setTestValue', testSupportIndex.defaultValue);
    const dataForExcel = [
      {
        Type: 'Programmation',
        Minimum: getters.calculTotalProgMin(rootState.projectTasks.projectTasks),
        Maximum: getters.calculTotalProgMax(rootState.projectTasks.projectTasks),
      },
      {
        Type: 'Analyse',
        Minimum: getters.calculTotalAnalysisMin(rootState.projectTasks.projectTasks),
        Maximum: getters.calculTotalAnalysisMax(rootState.projectTasks.projectTasks),
      },
      {
        Type: 'QA',
        Minimum: getters.calculTotalQaMin(rootState.projectTasks.projectTasks),
        Maximum: getters.calculTotalQaMax(rootState.projectTasks.projectTasks),
      },

      {
        Type: 'Post-QA Dev',
        Minimum: getters.calculTotalPostQaDevMin(rootState.projectTasks.projectTasks),
        Maximum: getters.calculTotalPostQaDevMax(rootState.projectTasks.projectTasks),
      },
      {
        Type: 'Support aux tests client',
        Minimum: getters.calculSupportTestClientMin(rootState.projectTasks.projectTasks),
        Maximum: getters.calculSupportTestClientMax(rootState.projectTasks.projectTasks),
      },
      {
        Type: 'Gestion technique',
        Minimum: getters.calculTotalGestionTechMin(rootState.projectTasks.projectTasks),
        Maximum: getters.calculTotalGestionTechMax(rootState.projectTasks.projectTasks),
      },
      {
        Type: 'Deploiement',
        Minimum: rootState.resume.deploiementMin,
        Maximum: rootState.resume.deploiementMax,
      },
      {
        Type: 'Gestion',
        Minimum: rootState.resume.gestionProjetMin,
        Maximum: rootState.resume.gestionProjetMax,
      },
    ];
    commit('resume', dataForExcel);
  },
};

export const getters = {
  calculTotalProgMin: () => (tasksList) => {
    let totalProgMinResume = null;
    if (tasksList.length > 0) {
      for (let i = 0; i < tasksList.length; i += 1) {
        totalProgMinResume += tasksList[i].totalProgMin;
      }
      return Math.ceil(getDecimal(totalProgMinResume));
    }
    return null;
  },

  calculTotalProgMax: () => (tasksList) => {
    let totalProgMaxResume = null;
    if (tasksList.length > 0) {
      for (let i = 0; i < tasksList.length; i += 1) {
        totalProgMaxResume += tasksList[i].totalProgMax;
      }
      return Math.ceil(getDecimal(totalProgMaxResume));
    }
    return null;
  },

  calculTotalAnalysisMin: () => (tasksList) => {
    let totalAnalysisMinResume = null;
    if (tasksList.length > 0) {
      for (let i = 0; i < tasksList.length; i += 1) {
        totalAnalysisMinResume += tasksList[i].totalAnalysisMin;
      }
      return Math.ceil(getDecimal(totalAnalysisMinResume));
    }
    return null;
  },

  calculTotalAnalysisMax: () => (tasksList) => {
    let totalAnalysisMaxResume = null;
    if (tasksList.length > 0) {
      for (let i = 0; i < tasksList.length; i += 1) {
        totalAnalysisMaxResume += tasksList[i].totalAnalysisMax;
      }
      return Math.ceil(getDecimal(totalAnalysisMaxResume));
    }
    return null;
  },
  calculTotalGestionTechMin: () => (tasksList) => {
    let totalGestionTechResume = null;
    if (tasksList.length > 0) {
      for (let i = 0; i < tasksList.length; i += 1) {
        totalGestionTechResume += tasksList[i].totalGestionTechMin;
      }
      return Math.ceil(getDecimal(totalGestionTechResume));
    }
    return null;
  },

  calculTotalGestionTechMax: () => (tasksList) => {
    let totalGestionTechResume = null;
    if (tasksList.length > 0) {
      for (let i = 0; i < tasksList.length; i += 1) {
        totalGestionTechResume += tasksList[i].totalGestionTechMax;
      }
      return Math.ceil(getDecimal(totalGestionTechResume));
    }
    return null;
  },
  calculTotalQaMin: () => (tasksList) => {
    let totalQaMinResume = null;
    if (tasksList.length > 0) {
      for (let i = 0; i < tasksList.length; i += 1) {
        if (tasksList[i]) {
          totalQaMinResume += tasksList[i].totalQaMin;
        }
      }
      return Math.ceil(getDecimal(totalQaMinResume));
    }
    return null;
  },
  calculTotalQaMax: () => (tasksList) => {
    let totalQaMaxResume = null;
    if (tasksList.length > 0) {
      for (let i = 0; i < tasksList.length; i += 1) {
        if (tasksList[i]) {
          totalQaMaxResume += tasksList[i].totalQaMax;
        }
      }
      return Math.ceil(getDecimal(totalQaMaxResume));
    }
    return null;
  },

  calculTotalPostQaDevMin: (state) => (tasksList) => {
    if (tasksList.length > 0) {
      let result = getDecimal(getters.calculTotalProgMin()(tasksList) * (state.postDevQaValue / 100));
      return Math.ceil(result);
    };
    return null;
  },
  calculTotalPostQaDevMax: () => (tasksList) => {
    if (tasksList.length > 0) {
      let result = getDecimal(getters.calculTotalProgMax()(tasksList) * (state.postDevQaValue / 100));
      return Math.ceil(result);
    }
    return null;
  },

  calculSupportTestClientMin: (state, getters, rootState) => (tasksList) => {
    if (tasksList.length > 0) {
      let result = getDecimal(getters.calculTotalQaMin(tasksList) * (state.TestSupportValue / 100));
      return Math.ceil(result);
    }
    return null;
  },

  calculSupportTestClientMax: (state, getters, rootState) => (tasksList) => {
    if (tasksList.length > 0) {
      let result = getDecimal(getters.calculTotalQaMax(tasksList) * (state.TestSupportValue / 100));
      return Math.ceil(result);
    }
    return null;
  },
  getDeploiementMin(state) {
    return state.deploiementMin;
  },
  getDeploiementMax(state) {
    return state.deploiementMax;
  }
};
export const mutations = {
  resume(state, payload) {
    state.resume = payload;
  },
  setQAValue(state, payload) {
    state.postDevQaValue = payload;
  },
  setTestValue(state, payload) {
    state.TestSupportValue = payload;
  },
  setDeploiementMin(state, payload) {
    state.deploiementMin = payload;
  },
  setDeploiementMax(state, payload) {
    state.deploiementMax = payload;
  },
  setGestionMin(state, payload) {
    state.gestionProjetMin = payload;
  },
  setGestionMax(state, payload) {
    state.gestionProjetMax = payload;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
